import React from 'react';
import { Box, Card, CardContent, Typography, Avatar, Grid, Chip } from '@mui/material';

/**
 * QuestionSetInfoCard - Displays question set metadata in a card
 *
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon component for the header
 * @param {string} props.sectionLabel - Label for the section (e.g., "Passage", "Part")
 * @param {string} props.sectionValue - Value for the section
 * @param {string} props.questionType - Type of question set
 * @param {string} props.questionInterval - Question interval (e.g., "1-5")
 * @param {number} props.questionCount - Total question count
 */
const QuestionSetInfoCard = ({
  icon,
  sectionLabel = 'Section',
  sectionValue,
  questionType,
  questionInterval,
  questionCount,
}) => {
  return (
    <Card sx={{ mb: 3, borderRadius: 3 }}>
      <CardContent sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Avatar sx={{ backgroundColor: 'info.main', width: 32, height: 32, mr: 2 }}>
            {icon}
          </Avatar>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
            Question Set Information
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'grey.50', borderRadius: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1 }}>
                {sectionLabel}
              </Typography>
              <Chip
                label={sectionValue}
                color="primary"
                variant="outlined"
                sx={{ fontWeight: 500 }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'grey.50', borderRadius: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1 }}>
                Question Type
              </Typography>
              <Chip
                label={questionType || 'N/A'}
                color="info"
                variant="outlined"
                sx={{ fontWeight: 500, fontFamily: 'monospace' }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'grey.50', borderRadius: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1 }}>
                Question Interval
              </Typography>
              <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 600 }}>
                {questionInterval || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'grey.50', borderRadius: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1 }}>
                Total Questions
              </Typography>
              <Typography variant="h6" sx={{ color: 'success.main', fontWeight: 600 }}>
                {questionCount || 0}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuestionSetInfoCard;
